import { atom } from 'recoil';

import { InvestmentsTransferPeriodDates } from './types';

export const initialReportPeriodDates: InvestmentsTransferPeriodDates = {
  startDate: null,
  endDate: null,
};

export const investmentsTransferSearchTermState = atom<string>({
  key: 'investmentsTransferSearchTermState',
  default: '',
});

export const investmentsTransferPeriodState = atom<InvestmentsTransferPeriodDates>({
  key: 'investmentsTransferPeriodState',
  default: initialReportPeriodDates,
});

export const investmentsTransferPageState = atom<number>({
  key: 'investmentsTransferPageState',
  default: 1,
});
